import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { CertificationModule } from '../certifications/certification.module';
import { UserDetailsCardModule } from '../shared/user-details-card/user-details-card.module';
import { CertificatesFilterByDialogComponent } from './components/dialogs/certificates-filter-by-dialog/certificates-filter-by-dialog.component';
import { ProvidersListDialogComponent } from './components/dialogs/providers-list-dialog/providers-list-dialog.component';
import { ReplaceCertificateDialogComponent } from './components/dialogs/replace-certificate-dialog/replace-certificate-dialog.component';
import { CertificateDateFilterComponent } from './components/filters/certificate-date-filter/certificate-date-filter.component';
import { CertificationsFilterComponent } from './components/filters/certifications-filter/certifications-filter.component';
import { CertificatesStatusFilterComponent } from './components/filters/status-filter/certificates-status-filter.component';
import { CertificatesTeamMembersFilterComponent } from './components/filters/team-members-filter/certificates-team-members-filter.component';
import { CertificatesTeamsFilterComponent } from './components/filters/teams-filter/certificates-teams-filter.component';
import { CertificatesUsersFilterComponent } from './components/filters/users-filter/certificates-users-filter.component';
import { ProvidersAllListComponent } from './components/providers-all-list/providers-all-list.component';
import { CertificationProviderApiService } from './services/certification-provider.api-service';
import { CertificationProviderService } from './services/certification-provider.service';

@NgModule({
    imports: [
        MaxBrainSharedModule,
        MatChipsModule,
        MatIconModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatMenuModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatTreeModule,
        MatCheckboxModule,
        TranslateModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        FormsModule,
        CertificationModule,
        UserDetailsCardModule,
        MatSlideToggleModule,
        RouterModule,
        MatDatepickerModule,
        MatTooltipModule,
    ],
    providers: [CertificationProviderApiService, CertificationProviderService],
    declarations: [
        ProvidersAllListComponent,
        ReplaceCertificateDialogComponent,
        CertificatesFilterByDialogComponent,
        CertificatesStatusFilterComponent,
        CertificationsFilterComponent,
        CertificateDateFilterComponent,
        CertificatesTeamsFilterComponent,
        CertificatesUsersFilterComponent,
        CertificatesTeamMembersFilterComponent,
        ProvidersListDialogComponent,
    ],
    exports: [ProvidersAllListComponent, ReplaceCertificateDialogComponent, ProvidersListDialogComponent],
})
export class CertificationProviderModule {
    static forRoot(): ModuleWithProviders<CertificationProviderModule> {
        return {
            ngModule: CertificationProviderModule,
            providers: [CertificationProviderApiService],
        };
    }
}
